import i18n from "i18n"
import { request, IAPinUseError, RequestError } from "utils/request"

/**
 * limsRequest — the single seam for all net-new LIMS data (specifications, results,
 * consumables/standards, OOS, forskrifter, audit, e-signatures).
 *
 * SPEC-021 cutover: the localStorage mock (USE_MOCK / ptLimsMock:*) is GONE — every call
 * forwards to the shared request() helper against the real SP-E backend. Envelope
 * conventions match the backend: {input}/{patch} in, {items}/{item}/{id} out (BaseSchema
 * camelCases all keys). See docs/specs/lims-api-contract.md.
 *
 * Existing entities (samples, assets, analyses) keep using request() directly and do NOT
 * go through here.
 *
 * Error mapping: the shared request() maps HTTP 409 to IAPinUseError with the misleading
 * fallback text "IAP is in use" (an IAP concept that does not exist in LIMS). The backend's
 * LIMS routes raise 409 Conflict with a precise description (e.g. "Only a draft result can
 * be saved"); when that description is present it is surfaced verbatim, and only a 409
 * WITHOUT a usable message falls back to the generic LIMS conflict text.
 */

// The fallback message request() substitutes when a 409 response carries no body message.
const IAP_FALLBACK_MESSAGE = "IAP is in use"

function mapLimsError(err) {
  if (err instanceof IAPinUseError) {
    const hasRealMessage = err.message && err.message !== IAP_FALLBACK_MESSAGE
    return new RequestError(
      hasRealMessage ? err.message : i18n.t("limsConflictError", { ns: "common" })
    )
  }
  return err
}

export function limsRequest(method, path, body) {
  return request(method, path, body).catch((err) => {
    throw mapLimsError(err)
  })
}
